import { getYandexStoreImageMin, getNdsValue } from '../../../../helpers';
import React, { useEffect, useState } from 'react';
import { showModal } from '../../../../actions/modal';
import { editCurrentSupply } from '../../../../actions/supplies';
import { useDispatch, useSelector } from 'react-redux';
import Editable from '../../../common/Editable';
import DesktopLayout from './DesktopLayout';
import isMobile from 'ismobilejs';
import MobileLayout from './MobileLayout';
import Adaptive from '../../../common/Adaptive';
import { SUPPLIES_TABS_NAME } from '../../../../config';

const ItemTD = (props) => {
  const { sectionName, sectionValue, currentSupply, itemIndex, activeTab } = props;
  const [value, setValue] = useState(sectionValue);
  const [editing, setEditing] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setValue(sectionValue);
  }, [sectionValue]);

  useEffect(() => {
    if (!value && editing) setValue('0');
  }, [value, editing]);

  const handleCancel = () => {
    setValue(sectionValue);
    setEditing(false);
  };

  const handleUpdate = () => {
    setEditing(false);
    const newItems = currentSupply.planItems;
    newItems[itemIndex][sectionName] = value;
    dispatch(
      editCurrentSupply({
        ...currentSupply,
        planItems: newItems,
      }),
    );
  };

  const handleChange = (evt) => {
    if (evt.target.value) {
      const tmp = parseInt(evt.target.value);
      if (tmp) setValue(tmp);
    } else {
      setValue(0);
    }
  };

  return (
    <>
      <Editable
        {...props}
        value={value}
        toggleInput={() => setEditing(true)}
        handleUpdate={handleUpdate}
        onChange={handleChange}
        currentInput={editing && value}
        handleCancel={handleCancel}
        activeTab={activeTab}
      />
    </>
  );
};

const Item = (props) => {
  const {
    item,
    itemIndex,
    currentWarehouse,
    setQuantityFactChange,
    handleEditSupplyOrder,
    showBatchAccInfo,
    defaultReserve,
    hasRelatedOrder,
    activeTab,
    batchAccountingDataKey,
  } = props;

  const dispatch = useDispatch();
  const currentSupply = useSelector((state) => state.supplies.currentSupply);

  const isManualSupply = currentWarehouse && currentWarehouse.operatorType === 'MANUAL';

  const [hoverRow, setHoverRow] = useState(false);

  const handleEditItem = (itemIdx) => {
    if (isSupplyClosed) {
      return;
    }

    dispatch(
      showModal('EditOrderItem', {
        currentItem: currentSupply.planItems[itemIdx],

        submitCallback: (values) => {
          const newItems = [
            ...currentSupply.planItems.slice(0, itemIdx),
            {
              ...currentSupply.planItems[itemIdx],
              price: values.price,
              quantity: values.quantity,
              vatRate: values.vatRate,
            },
            ...currentSupply.planItems.slice(itemIdx + 1),
          ];

          dispatch(
            editCurrentSupply({
              ...currentSupply,
              planItems: newItems,
            }),
          );
        },
      }),
    );
  };

  const handleEditBatchOrderItem = (itemIdx) => {
    if (isSupplyClosed) {
      return;
    }

    dispatch(
      showModal('EditBatchOrderItem', {
        currentItem: currentSupply.planItems[itemIdx],

        submitCallback: (values) => {
          const newItems = [
            ...currentSupply.planItems.slice(0, itemIdx),
            {
              ...currentSupply.planItems[itemIdx],
              batchAccountingAttributes: {
                ...values,
              },
            },
            ...currentSupply.planItems.slice(itemIdx + 1),
          ];

          dispatch(
            editCurrentSupply({
              ...currentSupply,
              planItems: newItems,
            }),
          );
        },
        deleteCallback: () => {
          const newItems = [
            ...currentSupply.planItems.slice(0, itemIdx),
            {
              ...currentSupply.planItems[itemIdx],
              batchAccountingAttributes: undefined,
            },
            ...currentSupply.planItems.slice(itemIdx + 1),
          ];

          dispatch(
            editCurrentSupply({
              ...currentSupply,
              planItems: newItems,
            }),
          );
        },
      }),
    );
  };

  const handleRemoveItem = (itemIndex) => {
    const newItems = [
      ...currentSupply.planItems.slice(0, itemIndex),
      ...currentSupply.planItems.slice(itemIndex + 1),
    ]
      //api тербует непрерывность нумерации. Поэтому перенумеруем поля
      .map((item, idx) => ({
        ...item,
        num: idx + 1,
      }));

    dispatch(
      editCurrentSupply({
        ...currentSupply,
        planItems: newItems,
      }),
    );
  };

  const isSupplyClosed =
    currentSupply.status === 'COMPLETED' ||
    currentSupply.status === 'COMPLETED_WITH_DIFFERENCE' ||
    currentSupply.status === 'CANCELED';
  const quantityFactEditable = isManualSupply && !isSupplyClosed;
  const quantityFact = isSupplyClosed ? item.quantityFact : item.quantityRaw;
  const quantityFactColor = quantityFact !== item.quantity ? 'item-price-quantity-red' : '';
  const quantityDefective = item.quantityDefective;
  const quantityDefectiveColor =
    quantityDefective !== item.quantity ? 'item-price-quantity-red' : '';
  const quantityEditableClass = isSupplyClosed ? '' : 'item-price-quantity-editable';

  const handleEditAccountingAttributes = (itemIndex) => {
    dispatch(
      showModal('EditAccountingAttributes', {
        currentItem: currentSupply.planItems[itemIndex],

        submitCallback: (newAccountingAttributes) => {
          const newItems = [
            ...currentSupply.planItems.slice(0, itemIndex),
            {
              ...currentSupply.planItems[itemIndex],
              accountingAttributeTitles: newAccountingAttributes,
            },
            ...currentSupply.planItems.slice(itemIndex + 1),
          ];

          dispatch(
            editCurrentSupply({
              ...currentSupply,
              planItems: newItems,
            }),
          );
        },
      }),
    );
  };

  const openEditSupplyTagModal = () => {
    dispatch(showModal('EditSupplyTag', {}));
  };

  const adaptiveProps = {
    setHoverRow,
    getYandexStoreImageMin,
    item,
    quantityEditableClass,
    itemIndex,
    getNdsValue,
    quantityFactEditable,
    ItemTD,
    hoverRow,
    currentSupply,
    quantityFactColor,
    quantityFact,
    quantityDefectiveColor,
    quantityDefective,
    isSupplyClosed,
    showBatchAccInfo,
    handleRemoveItem,
    handleEditSupplyOrder,
    defaultReserve,
    hasRelatedOrder,
    activeTab,
    handleEditItem: activeTab === SUPPLIES_TABS_NAME.PLAN ? handleEditItem : () => {},
    handleEditBatchOrderItem:
      activeTab === SUPPLIES_TABS_NAME.PLAN ? handleEditBatchOrderItem : () => {},
    handleEditAccountingAttributes:
      activeTab === SUPPLIES_TABS_NAME.PLAN ? handleEditAccountingAttributes : () => {},
    openEditSupplyTagModal,
    batchAccountingDataKey,
  };

  return (
    <Adaptive
      DekstopComponent={DesktopLayout}
      MobileComponent={MobileLayout}
      adaptiveProps={adaptiveProps}
    />
  );
};

export default Item;
